module.exports = __webpack_public_path__ + "img/logo.83b5b37d.svg";